module.exports = __webpack_public_path__ + "static/media/light-blue-wave.9a7761de.svg";